export default "__VITE_ASSET__BjEiFAOU__"